import { useLocalization } from 'common/providers/LocaleProvider';
import { trackCloseButtonClick } from '../tracking';

interface SideNavHeaderProps {
  navigationParentName: string;
  onClickCloseButton: () => void;
  onBackButtonClick: () => void;
  shopName?: string;
}

export const useSideNavTracking = ({
  navigationParentName,
  onClickCloseButton,
  onBackButtonClick,
  shopName,
}: SideNavHeaderProps) => {
  const { r, t } = useLocalization();

  return {
    backButtonProps: {
      'aria-label': r(t('h24_back_to_category'), { name: navigationParentName }),
      'data-testid': 'sidenav-back-button',
      onClick: onBackButtonClick,
    },
    closeButtonProps: {
      'aria-label': t('h24_close_menu'),
      'data-testid': 'sidenav-close-button',
      onClick: () => {
        onClickCloseButton();
        trackCloseButtonClick(t('h24_close_menu'), shopName);
      },
    },
  };
};
